export default (root: string) => ({
    deployments: `${root}/deployments`,
    deployment: (deploymentId: string) => {
        const specificRoot = `${root}/deployments/${deploymentId}`;
        return {
            root: specificRoot,
        };
    }
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/deployments/deploymentRouteLinks.ts